export default __webpack_public_path__ + "static/media/Twitter.be3baf19.svg";